import React, { useState } from 'react';
import "./companyStyles/company.scss";
import 'bootstrap/dist/css/bootstrap.min.css';

import cmpimg1 from "../../assets/images/technician-plug-cpu-microprocessor-motherboard-socket.png";
import cmpimg2 from "../../assets/images/engineers-working-digital-car-design-hightech-automotive-factory.png";
import cmpimg3 from "../../assets/images/side-view-attractive-hispanic-software-developer-programming-using-computer-while-working-from-home.png";
import { ReactComponent as ArrowIcon } from "../../assets/images/arrow_svg.svg";

const sections = [
  {
    id: 'industry',
    title: 'We drive industry automation',
    hoverText: 'industrial\nengineering company.',
    btnColor: 'red',
    image: cmpimg1,
  },
  {
    id: 'roadcraft',
    title: 'We power exceptional mobility',
    hoverText: 'mobility\nengineering company.',
    btnColor: 'cyan',
    image: cmpimg2,
  },
  {
    id: 'software',
    title: 'We power software innovation',
    hoverText: 'software\nengineering company.',
    btnColor: 'purple',
    image: cmpimg3,
  }
];

const urlMapping = {
  industry: "https://ettikengineering.com/",
  roadcraft: "https://www.ettiksoft.com/",
  software: "http://codewents.com/"
};

// A quick helper to check if user is on mobile. (Not foolproof, but good enough for a toggle.)
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

const EngineeringCompany = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const handleGoClick = (id) => {
    const url = urlMapping[id];
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleCardClick = (sectionId) => {
    // On desktop, the SCSS :hover does the “hover-content” display,
    // so we only toggle expanded on mobile
    if (isMobileDevice()) {
      if (expandedCard === sectionId) {
        // If user taps the same card again, collapse it
        setExpandedCard(null);
      } else {
        // Expand the newly tapped card
        setExpandedCard(sectionId);
      }
    }
  };

  return (
    <div className="company-section">
      <div className="fullscreen section dark-section">
        <div className="company-wrapper">
          <div className="company-row">
            {sections.map((section) => (
              <div key={section.id} className="section-card-wrapper">
                {/* Entire card clickable */}
                <div
                  className={`section-card ${section.id}`}
                  style={{ backgroundImage: `url(${section.image})` }}
                  onClick={() => handleCardClick(section.id)}
                >
                  <div className="overlay">
                    {/* 
                      On mobile, we’ll conditionally show/hide these two blocks 
                      based on expandedCard state. On desktop, the :hover effect
                      in SCSS still works.
                    */}
                    
                    {/* DEFAULT CONTENT */}
                    <div
                      className="default-content"
                      style={
                        isMobileDevice()
                          ? {
                              display:
                                expandedCard === section.id ? 'none' : 'block'
                            }
                          : {}
                      }
                    >
                      <p>{section.title}</p>
                      <ArrowIcon className="arrow-icon" />
                    </div>
                    
                    {/* HOVER CONTENT */}
                    <div
                      className="hover-content"
                      style={
                        isMobileDevice()
                          ? {
                              display:
                                expandedCard === section.id ? 'flex' : 'none'
                            }
                          : {}
                      }
                    >
                      <p>{section.hoverText}</p>
                      <button
                        className={`btn btn-lg btn-${section.btnColor} btn-round`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent also toggling card
                          handleGoClick(section.id);
                        }}
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="bottom-text">
            <p>an engineering company.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EngineeringCompany;
